<template>
  <div>
    <slot name="css">
      <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
    </slot>
    <template v-if="$store.getters['isOpen'] === true">
      <slot name="button">
        <!-- div :class="$store.getters['step'] === 'chatbox' ? 'gb-zb-button gb-zb-open' : 'gb-zb-button gb-zb-closed' "
             v-if="['button', 'chatbox'].indexOf($store.getters['step']) > -1 "
             v-on:click="toggleWidget">
        </div -->
      </slot>

      <div class="gb-zb-widget-wrapper gb-zb-open" :class="getClass"
           v-if="$store.getters['step'] === 'chatbox' "
           :data-gb-account="$settings.account">
        <div class="gb-zb-widget-header">
          <div>
            <slot name="header">
              <strong>Bonjour !</strong>
              <div class="gb-zb-widget-opacity">
                Démarrer une conversation
              </div>
            </slot>
          </div>
        </div>
        <span class="gb-zb-widget-close"></span>
        <div class="gb-zb-widget">
          <div v-for="(msg, index) in $store.getters['messages']"
               :key="index" >
            <div v-for="(rich_content, jndex) in msg.rich_content"
                 v-bind:key="jndex">
              <!-- {{ rich_content.kind }} -->
              <template v-if="rich_content.kind === 'txt' ">
                <content-txt :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'choice' ">
                <content-choice :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'choosed' ">
                <content-choosed :content=rich_content :date="msg.created" />
              </template>
              <template v-if="rich_content.kind === 'file' ">
                <content-file :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'location' ">
                <content-location :content=rich_content :index=jndex :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'payment' ">
                <payment :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'payment_result' ">
                <payment-succeeded :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'satisfaction' ">
                <survey-choice :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'timeslot_choice' ">
                <timeslot-choice :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'timeslots' ">
                <timeslots :content=rich_content :date="msg.created" />
              </template>
              <template v-else-if="rich_content.kind === 'url' ">
                <content-url :content=rich_content :target="'_blank'" :date="msg.created" />
              </template>
            </div>
          </div>
          <loader v-if="$store.getters['isLoaderSeen'] === true" />
        </div>
        <div class="gb-zb-form">
          <upload :url=url :acceptedFileTypes=acceptedFileTypes
                  :maxFileSize=maxFileSize
                  :postUploadHandler=postUploadHandler
                  v-if="$store.getters['isUpload']">
          </upload>
          <form v-on:submit.prevent="submitForm"
                v-if="!$store.getters['isUpload']">
            <input :type="$store.getters['inputType']" name="message"
                   :placeholder="$t('form.placeholder')"
                   v-model="userMsg"
                   autocomplete="off">
            <button name="send" class="gb-zb-send">
              <i class="material-icons">send</i>
            </button>
          </form>
          <div class="gb-zb-emoji emoji-menu-wrapper">
            <emoji :addEmoji=addEmoji />
            <button v-on:click.prevent="toggleEmojiPicker" id="emoji-trigger"
                    class="btn btn-transparent btn-small">
              <i class="material-icons">sentiment_satisfied_alt</i>
            </button>
          </div>
          <button name="upload" class="gb-zb-upload" v-on:click="toggleUpload()">
            <i class="material-icons">add_circle_outline</i>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Widget from '../../components/Widget'

export default {
  name: 'Widget',
  extends: Widget,
  components: {
    Emoji: () => import(
      /* webpackChunkName: "component-emoji" */
      /* webpackPreload: -100 */
      '@/components/Emoji.vue')
  },
  computed: {
    getClass () {
      if (this.$store.getters.hasZenMsgButton === true) {
        return 'gb-zm-fixed-button'
      }
      return ''
    },
    step () {
      return this.$store.getters.step
    }
  },
  created () {
    this.$store.dispatch({
      type: 'changeStep',
      step: 'button'
    })
  },
  watch: {
    step (value, oldValue) {
      const preventDefault = (e) => {
        // Tester si on est dans un enfant de widget ou pas ??
        e.preventDefault()
      }
      let viewport
      const resizeHandler = () => {
        const isMobile = window.GbZenMsg.$settings.ua.isMobile
        if (isMobile) {
          if (value === 'chatbox' && viewport !== undefined) {
            // document.body.addEventListener(
            //   'touchmove', preventDefault, { passive: false })
            const widgetWrapper = document.querySelector('.gb-zb-widget-wrapper')
            const widget = document.querySelector(
              '.gb-zb-widget-wrapper .gb-zb-widget')
            const scrollPosition = window.pageYOffset
            document.body.classList.add('gb-zb-chat-open')
            document.body.style.height = `${viewport.height}px`
            document.body.style.overflow = 'hidden'
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollPosition}px`
            document.body.style.width = '100%'
            if (widgetWrapper) {
              widgetWrapper.style.height = `${viewport.height}px`
              widgetWrapper.style.top = `${scrollPosition}px`
              const widgetHeight = viewport.height - 140
              widget.style.height = `${widgetHeight}px`
            }
            window.setTimeout(() => {
              resizeHandler()
            }, 1000)
          } else {
            document.body.removeEventListener('touchmove', preventDefault)
            document.body.classList.remove('gb-zb-chat-open')
            document.body.style.height = 'auto'
            document.body.style.removeProperty('overflow')
            document.body.style.removeProperty('position')
            document.body.style.removeProperty('top')
            document.body.style.removeProperty('width')
            window.scrollTo(0, 0)
          }
        }
      }
      if (value === 'chatbox') {
        viewport = window.visualViewport

        if (window.visualViewport !== undefined) {
          window.visualViewport.addEventListener('resize', resizeHandler)
        }
      } else {
        if (window.visualViewport !== undefined) {
          window.visualViewport.removeEventListener('resize', resizeHandler)
        }
      }
    }
  }
}

</script>

<style lang="scss">
@import '../../components/widget.scss';

.gb-zb-button {
  display: none;
}
</style>
